import React, { useEffect, useState } from 'react'
import { CAlert, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../../shared/icons'
import { useUI } from '../../shared/ui/UIProvider'
import { request } from '../../services'

function prettyJson(value) {
  if (!value) return '{}'
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch (_) {
    return String(value)
  }
}

function ScriptCatalogConfigModal({ open, script, onClose, onSaved }) {
  const { toast } = useUI()
  const [text, setText] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!open || !script) return
    setError('')
    setText(prettyJson(script.config))
  }, [open, script])

  function format() {
    try {
      setText(JSON.stringify(JSON.parse(text), null, 2))
      setError('')
    } catch (parseError) {
      setError(`JSON invalido: ${parseError.message}`)
    }
  }

  async function save() {
    let normalized
    try {
      normalized = JSON.stringify(JSON.parse(text))
    } catch (parseError) {
      setError(`JSON invalido: ${parseError.message}`)
      toast('El JSON tiene un error de sintaxis', 'danger')
      return
    }
    setSaving(true)
    const res = await request('script_config_save', {
      method: 'POST',
      body: {
        uuid: script.uuid,
        name: script.name,
        url: script.url,
        description: script.description,
        status: String(script.status ?? 1),
        config: normalized,
      },
    })
    setSaving(false)
    if (!res.ok) {
      const detail = res.data?.error || 'No se pudo guardar la configuracion'
      setError(detail)
      toast(detail, 'danger')
      return
    }
    toast(`Configuracion de "${script.name}" guardada`, 'success')
    if (onSaved) onSaved()
    onClose()
  }

  return (
    <CModal visible={open} onClose={onClose} size="lg" alignment="center" scrollable>
      <CModalHeader>
        <CModalTitle><CIcon icon={icon('cilSettings')} className="me-2" /> Configuracion base · {script?.name}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p className="config-scope-note">
          Este es el JSON base del script (forms, remarks, opciones). Aplica a todas las asignaciones que no tengan una config propia.
        </p>
        {error ? <CAlert color="danger" onClose={() => setError('')} dismissible>{error}</CAlert> : null}
        <textarea
          className="config-editor"
          spellCheck={false}
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="{}"
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="light" onClick={format} disabled={saving}><CIcon icon={icon('cilCode')} /> Formatear</CButton>
        <CButton color="light" onClick={onClose} disabled={saving}>Cancelar</CButton>
        <CButton color="success" className="btn-brand" onClick={save} disabled={saving}>
          {saving ? <CSpinner size="sm" /> : 'Guardar configuracion'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ScriptCatalogConfigModal
